import { columnForField, defaultColumnWidth } from "../../Grid/columnForField";
import EdcOverviewItem from "./EdcOverviewItem";
import { customDecimalFilterCell } from "../../Layout/Filter/CustomDecimalFilterCell";

export const EdcGridColumns = () => {
  return [
    columnForField<EdcOverviewItem>("Gsdb", {
      title: "GSDB",
      locked: true,
      width: "175px",
    }),
    columnForField<EdcOverviewItem>("Name", { width: "200px" }),
    columnForField<EdcOverviewItem>("Details", { width: "200px" }),
    columnForField<EdcOverviewItem>("Street", { width: "300px" }),
    columnForField<EdcOverviewItem>("ZipCode", {
      title: "Postcode",
      width: defaultColumnWidth,
    }),
    columnForField<EdcOverviewItem>("ZipArea", {
      title: "Postcode Area",
      width: defaultColumnWidth,
    }),
    columnForField<EdcOverviewItem>("City", {
      width: "200px",
    }),
    columnForField<EdcOverviewItem>("Region", {
      width: defaultColumnWidth,
    }),
    columnForField<EdcOverviewItem>("CountryName", {
      title: "Country",
      width: "200px",
    }),
    columnForField<EdcOverviewItem>("Latitude", { width: "200px" }),
    columnForField<EdcOverviewItem>("Longitude", { width: "200px" }),
    columnForField<EdcOverviewItem>("MgLatitude", {
      title: "M&G Latitude",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: "150px",
    }),
    columnForField<EdcOverviewItem>("MgLongitude", {
      title: "M&G Longitude",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: "150px",
    }),
  ];
};
